import { Button } from "antd";
import moment from "moment"
import helper from "../helper";
// import helper from 't18helper/dist/fetchHelper';


var obj = {
    "name": "driver",
    "collection": false,
    "displayConfig": {
        "view": true,
        "edit": true,
        "createNew": true,
        "showTable": true,
        "bulkCreate": true,
        "filters": true
    },
    "columns": [
        {

            "title": "Vendor Id",
            "dataIndex": "_id",
            "key": "_id",
            "showInTable": false,
            "type": "image",
            "filter": false,
            "secure": false,
            "disableInForm": true,
            "optional": true,
            "colors": [{ "enum1": "red", "enum2": "blue" }],
            "children": [{}, {}, {}],
            "default": "String -> Any",
            "arr": ["val1", "val2", "val3"],
            "values": ["id1", "id2", "id3"],
            "render": "Function"

        },
        {

            "title": "Name",
            "dataIndex": "name",
            "key": "name",
            "showInTable": true,
            "type": "string",
            "filter": false,
            "secure": false,
            "disableInForm": true,
            "optional": true,
            "colors": [{ "enum1": "red", "enum2": "blue" }],
            // "children": [{}, {}, {}],
            // "default": "String -> Any",
            // "arr": ["val1", "val2", "val3"],
            // "values": ["id1", "id2", "id3"],
            // "render": "Function"

        },
        {

            "title": "Phone Number",
            "dataIndex": "phone",
            "key": "phone",
            "showInTable": true,
            "type": "string",
            "filter": false,
            "secure": false,
            "disableInForm": true,
            "optional": true,
            "colors": [{ "enum1": "red", "enum2": "blue" }],
            // "children": [{}, {}, {}],
            // "default": "String -> Any",
            // "arr": ["val1", "val2", "val3"],
            // "values": ["id1", "id2", "id3"],
            // "render": "Function"

        },
        {

            "title": "Email",
            "dataIndex": "email",
            "key": "email",
            "showInTable": true,
            "type": "string",
            "filter": false,
            "secure": false,
            "disableInForm": true,
            "optional": true,
            "colors": [{ "enum1": "red", "enum2": "blue" }],
            // "children": [{}, {}, {}],
            // "default": "String -> Any",
            // "arr": ["val1", "val2", "val3"],
            // "values": ["id1", "id2", "id3"],
            // "render": "Function"

        }
        ,
        {

            "title": "Status",
            "dataIndex": "status",
            "key": "status",
            "showInTable": true,
            "type": "enum",
            "filter": true,
            "secure": false,
            "disableInForm": true,
            "optional": true,
            "colors": { "pending": "red", "approved": "blue" },
            // "children": [{}, {}, {}],
            // "default": "String -> Any",
            "arr": ["pending", "approved"],
            // "values": ["id1", "id2", "id3"],
            // "render": "Function"

        }
        ,
        {

            "title": "Created On",
            "dataIndex": "cOn",
            "key": "cOn",
            "showInTable": true,
            "type": "date",
            "filter": false,
            "secure": false,
            "disableInForm": true,
            "optional": true,
            "colors": { "pending": "red", "approved": "blue" },
            // "children": [{}, {}, {}],
            // "default": "String -> Any",
            // "arr": ["val1", "val2", "val3"],
            // "values": ["id1", "id2", "id3"],
            "render": (val) => moment(val).format("DD-MM-YYYY")

        }
        ,
        {

            "title": "Approve",
            "dataIndex": "cOn",
            "key": "cOn",
            "showInTable": true,
            "type": "date",
            "filter": false,
            "secure": false,
            "disableInForm": true,
            "optional": true,
            "colors": { "pending": "red", "approved": "blue" },
            // "children": [{}, {}, {}],
            // "default": "String -> Any",
            // "arr": ["val1", "val2", "val3"],
            // "values": ["id1", "id2", "id3"],
            "render": (val, record) => {

                return (
                    <>
                        {record.status == "pending" && <Button type="primary" size="small" style={{ borderColor: "green", color: 'green' }} ghost
                            onClick={async () => {
                                console.log("clicked", record._id);
                                let res = await helper.updateData({ id: record._id, "status": "approved" }, "driverStatus")
                                console.log(res)
                                if (res.status === 200) {
                                    helper.message.success('approved successfully')
                                    // await this.getData()
                                    return res
                                }
                                return helper.message.error('error approving data')

                            }}>Approve</Button>}
                    </>

                );
            }

        }
    ]

}


export { obj }